/* eslint-disable react/no-multi-comp */

import React from 'react'
import { FormattedMessage } from 'react-intl'

import { UNIT_TYPES } from 'constants'

export const UNAVAILABLE_BATTLE_MESSAGES_TODAY = (peripheryName, availableTime) => ({
    [UNIT_TYPES.SORTIE]: (
        <FormattedMessage
            id='unavailable_battle.message.sortie_today'
            defaultMessage='Вылазки на сервере {peripheryName} начнутся сегодня в {availableTime}'
            values={{
                peripheryName,
                availableTime,
            }}
        />
    ),
    [UNIT_TYPES.FORT_BATTLE]: (
        <FormattedMessage
            id='unavailable_battle.message.fort_battle_today'
            defaultMessage='Наступления на сервере {peripheryName} начнутся сегодня в {availableTime}'
            values={{
                peripheryName,
                availableTime,
            }}
        />
    ),
})

export const UNAVAILABLE_BATTLE_MESSAGES_TOMORROW = (peripheryName, availableTime) => ({
    [UNIT_TYPES.SORTIE]: (
        <FormattedMessage
            id='unavailable_battle.message.sortie_tomorrow'
            defaultMessage='Вылазки на сервере {peripheryName} начнутся завтра в {availableTime}'
            values={{
                peripheryName,
                availableTime,
            }}
        />
    ),
    [UNIT_TYPES.FORT_BATTLE]: (
        <FormattedMessage
            id='unavailable_battle.message.fort_battle_tomorrow'
            defaultMessage='Наступления на сервере {peripheryName} завтра в {availableTime}'
            values={{
                peripheryName,
                availableTime,
            }}
        />
    ),
})

export const UNAVAILABLE_CURRENT_PERIPHERY_MESSAGES = {
    [UNIT_TYPES.SORTIE]: (
        <FormattedMessage
            id='unavailable_current_periphery.sorties'
            defaultMessage='Вылазки недоступны. Время начала станет известно позже.'
        />
    ),
    [UNIT_TYPES.FORT_BATTLE]: (
        <FormattedMessage
            id='unavailable_current_periphery.fort_battles'
            defaultMessage='Наступления недоступны. Время начала станет известно позже.'
        />
    ),
}

export const UNAVAILABLE_BATTLE_AVAILABLE_SERVERS = {
    [UNIT_TYPES.SORTIE]: (
        <FormattedMessage
            id='unavailable_battle.available_servers.sortie'
            defaultMessage='Сейчас Вылазки доступны на серверах:'
        />
    ),
    [UNIT_TYPES.FORT_BATTLE]: (
        <FormattedMessage
            id='unavailable_battle.available_servers.fort_battle'
            defaultMessage='Сейчас Наступления доступны на серверах:'
        />
    ),
}

export const UNAVAILABLE_BATTLE_FOOTER_MESSAGE = (icon) => {
    return (
        <FormattedMessage
            id='unavailable_battle.footer_message'
            defaultMessage='To select a different server, close the mode selection window and click on {icon} in the bottom right corner.'// eslint-disable-line max-len
            values={{ icon }}
        />
    )
}

export const UNAVAILABLE_BATTLE_FINE_WARNING = (
    <FormattedMessage
        id='unavailable_battle.fine_warning'
        defaultMessage='Действует штраф: участие в Наступлениях недоступно'
    />
)

export const UNAVAILABLE_BATTLE_FINE_CONDITIONS = (
    <FormattedMessage
        id='unavailable_battle.fine_conditions'
        defaultMessage='Игроки клана смогут создавать отряды для Наступлений, как только будет заработан недостающий промресурс для погашения штрафа.'// eslint-disable-line max-len
    />
)



// WEBPACK FOOTER //
// ./components/BattleWizard/components/UnavailableBattle/constants.jsx